import { render, staticRenderFns } from "./EmployeeDataDocuments.vue?vue&type=template&id=2299f82d&"
import script from "./EmployeeDataDocuments.vue?vue&type=script&lang=js&"
export * from "./EmployeeDataDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports